import React from 'react'
import Image from 'next/image'
import Link from 'next/link'
import OfferOutUrl from '@/components/shared/OfferOutUrl'
import { getBaseImageUrl, getMerchantHref } from '@/constants/hooks'
import { OffersMerchant, OffersOffer } from '@/services/dataTypes'

interface Props {
    data: OffersOffer
    merchant?: OffersMerchant
    height?: number
    width?: number
    offerLink?: string | null
    mer_slug?: string
    slug_type?: string
    domain: string
    unoptimized?: boolean
}

const Banner = ({ data, height, width, offerLink, mer_slug, slug_type, domain, unoptimized = false }: Props) => {
    const { offer_title, offer_detail, banner_image, url } = data?.offer ?? {}

    const img = (
        <Image
            src={getBaseImageUrl(domain, banner_image, '')}
            alt={offer_title || offer_detail || 'banner'}
            className="object-contain rounded-xl"
            loading="lazy"
            height={height || 200}
            width={width || 300}
            unoptimized={unoptimized}
        />
    )

    return (
        <div className="w-full flex items-center justify-center overflow-hidden">
            {mer_slug && slug_type ? (
                <OfferOutUrl
                    outUrl={offerLink || url}
                    unique_id={data.offer.unique_id}
                    merchantHref={getMerchantHref(data?.merchant, mer_slug, slug_type)}
                    domain={domain}
                >
                    {img}
                </OfferOutUrl>
            ) : (
                <Link href={offerLink || url} rel="nofollow sponsored noopener noreferrer" className="flex items-center justify-center w-full">
                    {img}
                </Link>
            )}
        </div>
    )
}

export default Banner
